<template>
  <div id="wrap">
    <HeadView v-if="$store.getters.isPC"></HeadView>
    <template v-else>
      <MobileHeadView></MobileHeadView>
    </template>
    <el-container class="pc_el_container">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </el-container>
    <FooterView v-if="$store.getters.isPC"></FooterView>
    <template v-else>
    <MobileFooterView v-if="!isYiban"></MobileFooterView>
    </template>
  </div>
</template>

<script>
import HeadView from '@/components/Head'
import MobileHeadView from '@/components/MobileHead'
import FooterView from '@/components/Footer'
import MobileFooterView from '@/components/MobileFooter'
export default {
  components: {
    HeadView,
    MobileHeadView,
    FooterView,
    MobileFooterView
  },
  data () {
    return {
      isYiban: false
    }
  },
  created () {
    try {
      if (localStorage.getItem('isForm') == 1) {
        this.isYiban = true
      }
    } catch (error) {}
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/Layout.vue